<template>
    <v-layout column class="community-directory">
        <v-flex xs12>
            <v-layout class="community-directory__list">
                <v-flex xs12>
                    <v-tabs
                            :class="activeTab === null ? 'bar-border' : ''"
                            v-model="activeTab"
                            color="white"
                            :mandatory="false"
                            hide-slider
                            mobile-break-point="600"
                    >
                        <v-tab v-for="ribbon in ribbonTitles"
                               :class="[
                                    isEnabledRibbon(ribbon) ? '' : 'disabled-tab',
                                    (communitySelectedFilters[ribbon.key] && communitySelectedFilters[ribbon.key].length) ? 'bold-ribbon' : '',
                                    currentRibbon && currentRibbon.name === ribbon.name ? 'active-filter-tab' : ''
                               ]"
                               :data-qe-id="`community_ribbon_tab_${ribbon.key}`"
                               @click="selectedComponent(ribbon)"
                               :key="ribbon.key">
                            {{ribbon.name}}
                        </v-tab>
                        <v-tab-item
                                :transition="false"
                                :reverse-transition="false"
                                v-for="(ribbon, index) in ribbonTitles"
                                :key="index"
                                v-if="activeTab !== null">
                            <component class="community-directory__component"
                                       :is="determineComponent()"
                                       v-bind="componentProps(ribbon)"
                            >
                            </component>
                        </v-tab-item>
                    </v-tabs>
                </v-flex>
            </v-layout>
            <v-layout column class="community-directory__pills" pt-1>
                <v-flex xs12>
                    <community-filter-pills-list
                            v-if="communitySelectedFilters"
                            :community-selected-filters="communitySelectedFilterPillList"
                            :handle-clear="removeAllFilters"
                            :handle-close="removeFilter">
                    </community-filter-pills-list>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex xs12>
            <v-layout class="rolodex-wrapper" v-if="showSortByDropDown || displayRolodex">
                <v-flex class="rolodex-wrapper__sort-by">
                    <sort-communities-by-options v-if="showSortByDropDown">
                    </sort-communities-by-options>
                </v-flex>
                <v-flex xs7 sm9 md10 class="rolodex-wrapper__rolodex">
                    <rolodex v-if="displayRolodex"
                             :set-directory-selected-letter="handleSelectedLetter"
                             :selected-letter-filter="communityDirectorySelectedLetterFilter"
                             :reset-selected-letter="removeSelectedLetter"
                             :filtered-letters-list="letterFilters">
                    </rolodex>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex xs12>
            <community-search-results> </community-search-results>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import CommunitySearchResults from './CommunitySearchResults';
    import { communityDirectoryPageConstant, ribbonTitles } from './communityDirectoryPage.constants';
    import { applyNumber } from "@/components/EventDirectoryPage/eventDirectoryPage.constants";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeMutation } from "../../store/storeMutations.constant";
    import { appCommonConstants } from "../appCommon.constants";
    import CommunityType from "./CommunityType";
    import Focus from "./Focus";
    import WhoCanParticipate from "./WhoCanParticipate";
    import { numberCommaSeparated } from "../../common/utils/utils";
    import CommunityFilterPill from "./CommunityFilterPill";
    import CommunityFilterPillsList from "./CommunityFilterPillsList";
    import SortCommunitiesByOptions from "./SortCommunitiesByOptions";
    import { appConstant } from "../../app.constant";
    import Rolodex from "../MemberDirectoryPage/Rolodex";

    export default {
        name: 'CommunityDirectory',
        created() {
            const filtersFromRoute = this.$route.query.communityFilters ? JSON.parse(this.$route.query.communityFilters) : null;
            const searchTextFromRoute = this.$route.query.communitySearchText ? this.$route.query.communitySearchText : '';

            if (filtersFromRoute) {
                if (filtersFromRoute.letterFilter && filtersFromRoute.letterFilter.length) {
                    this.setCommunitySelectedLetterFilter(filtersFromRoute.letterFilter[0]);
                }
                sessionStorage.setItem(appConstant.storageKeys.communityDirectoryStoredFilters, JSON.stringify(filtersFromRoute));
            }
            this.setCommunityStateFromRouter({
                communitySearchText: searchTextFromRoute,
                filters: filtersFromRoute,
            });
            this.getCommunityDirectoryResults();
        },
        components: {
            Rolodex,
            CommunitySearchResults,
            CommunityType,
            Focus,
            WhoCanParticipate,
            CommunityFilterPill,
            CommunityFilterPillsList,
            SortCommunitiesByOptions,
        },
        data() {
            return {
                appCommonConstants,
                communityDirectoryPageConstant,
                ribbonTitles,
                activeTab: null,
                selectedRibbonFilter: null,
                currentComponent: null,
                currentRibbon: null,
            };
        },
        methods: {
            ...mapActions({
                getCommunityDirectoryResults: `communityDirectory/${storeAction.getInitialCommunityDirectorySearchResults}`,
                clearAllCommunityFilters: `communityDirectory/${storeAction.clearAllCommunityFilters}`,
            }),
            ...mapMutations({
                clearCommunityState: `communityDirectory/${storeMutation.clearCommunityState}`,
                setCommunityStateFromRouter: `communityDirectory/${storeMutation.setCommunityStateFromRouter}`,
                setCommunitySelectedFiltersInState: `communityDirectory/${storeMutation.setCommunitySelectedFiltersInState}`,
                removeCommunityPillFromState: `communityDirectory/${storeMutation.removeCommunityPillFromState}`,
                setCommunitySelectedLetterFilter: `communityDirectory/${storeMutation.setCommunitySelectedLetterFilter}`,
            }),
            determineComponent() {
                return this.currentComponent;
            },
            componentProps(rib) {
                return {
                    activeComponent: this.currentComponent,
                    currentRibbon: this.ribbonTitles.find(title => title.component === rib.component),
                    postAction: this.cancel,
                    labelWithCount: this.labelWithCount,
                    isPreviouslySelected: this.isPreviouslySelected,
                    showRibbonCheckboxOption: this.showRibbonCheckboxOption,
                    updateRoute: this.updateRoute,
                    applyNumberCount: this.applyNumberCount,
                    ribbonItemFromApi: this.communityDirectoryResults &&
                    this.communityDirectoryResults.searchRibbonGroup &&
                    this.communityDirectoryResults.searchRibbonGroup.length > 0 ?
                        this.communityDirectoryResults.searchRibbonGroup.find(ribbon => ribbon.key === rib.key) : {},
                };
            },
            selectedComponent(ribbon) {
                this.currentComponent = ribbon.component;
                this.currentRibbon = ribbon;
            },
            cancel() {
                this.activeTab = null;
                this.selectedRibbonFilter = null;
            },
            isEnabledRibbon(ribbon) {
                let result = false;
                if (this.communityDirectoryResults && this.communityDirectoryResults.searchRibbonGroup &&
                    this.communityDirectoryResults.searchRibbonGroup.length > 0) {
                    const ribbonFromApi = this.communityDirectoryResults.searchRibbonGroup.find(item => item.key === ribbon.key);
                    if (ribbonFromApi && ribbonFromApi.filters) {
                        result = ribbonFromApi.filters.some(item => item.count > 0 || (item.subFilters && item.subFilters.length));
                    }
                }
                return result;
            },
            showRibbonCheckboxOption(ribbonItem) {
                return ribbonItem.count > 0 || (ribbonItem.subFilters && ribbonItem.subFilters.length > 0);
            },
            numberCommaSeparated,
            labelWithCount(filterItem, parentKey) {
                const { count } = filterItem;
                let countToShow = null;

                if (count > 0) {
                    countToShow = `(${numberCommaSeparated(count)})`;
                    if (this.communitySelectedFilters && parentKey) {
                        const itemInSf = this.communitySelectedFilters[parentKey].length;
                        if (itemInSf) {
                            countToShow = null;
                        }
                    }
                }
                return countToShow;
            },
            isPreviouslySelected(filterItem, selectedFilterList) {
                let result = false;
                if (filterItem && selectedFilterList) {
                    const itemInSf = selectedFilterList
                        .find(item => item.filterValue === filterItem.filterValue && item.filterKey === filterItem.filterKey);
                    if (itemInSf) {
                        result = true;
                    }
                }
                return result;
            },
            updateRoute(parentKey, selectedFilters) {
                this.setCommunitySelectedFiltersInState({
                    key: parentKey,
                    filters: selectedFilters,
                });
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        communityFilters: JSON.stringify(this.communitySelectedFilters),
                        communitySearchText: this.communitySearchText ? this.communitySearchText : '',
                    },
                });
                sessionStorage.setItem(appConstant.storageKeys.communityDirectoryStoredFilters, JSON.stringify(this.communitySelectedFilters));
            },
            removeFilter(filterItem) {
                this.removeCommunityPillFromState(filterItem);
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        communityFilters: JSON.stringify(this.communitySelectedFilters),
                        communitySearchText: this.communitySearchText,
                    },
                });
                sessionStorage.setItem(appConstant.storageKeys.communityDirectoryStoredFilters, JSON.stringify(this.communitySelectedFilters));
            },
            removeAllFilters() {
                let dataFromRoute = { ...this.$route.query };
                if (dataFromRoute && dataFromRoute.hasOwnProperty('communityFilters')) {
                    delete dataFromRoute.communityFilters;
                }
                
                if (this.communityDirectorySelectedLetterFilter) {
                    dataFromRoute = {
                        communityFilters: JSON.stringify({
                            letterFilter: [{ ...this.communityDirectorySelectedLetterFilter }],
                        }),
                    };
                }

                this.$router.push({
                    query: { ...dataFromRoute },
                });

                if (this.communityDirectorySelectedLetterFilter) {
                    sessionStorage.setItem(
                        appConstant.storageKeys.communityDirectoryStoredFilters,
                        JSON.stringify({ letterFilter: [{ ...this.communityDirectorySelectedLetterFilter }] }),
                    );
                } else {
                    this.clearAllCommunityFilters();
                    sessionStorage.removeItem(appConstant.storageKeys.communityDirectoryStoredFilters);
                }
            },
            applyNumberCount(newlySelected) {
                return applyNumber(this.communitySelectedFilters[this.currentRibbon.key], newlySelected);
            },
            handleSelectedLetter(letterFilter) {
                this.setCommunitySelectedLetterFilter(letterFilter);
                this.updateRoute('letterFilter', [letterFilter]);
            },
            removeSelectedLetter() {
                this.removeFilter(this.communityDirectorySelectedLetterFilter);
                this.setCommunitySelectedLetterFilter();
            },
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters({
                communityDirectoryResults: `communityDirectory/${storeGetters.communityDirectoryResults}`,
                communityState: `communityDirectory/${storeGetters.communityState}`,
                communitySelectedFilters: `communityDirectory/${storeGetters.communitySelectedFilters}`,
                communitySearchText: `communityDirectory/${storeGetters.communityDirectorySearchText}`,
                communityDirectorySelectedLetterFilter: `communityDirectory/${storeGetters.communityDirectorySelectedLetterFilter}`,
            }),
            voucher() {
                return this.memberVoucher
                    ? this.memberVoucher
                    : [];
            },
            communitySelectedFilterPillList() {
                const selectedFilterPillObject = {
                    ...this.communitySelectedFilters,
                };

                if (selectedFilterPillObject.hasOwnProperty('letterFilter')) {
                    delete selectedFilterPillObject.letterFilter;
                }
                return selectedFilterPillObject;
            },
            letterFilters() {
                return this.communityDirectoryResults && this.communityDirectoryResults.quickSearchResults
                && this.communityDirectoryResults.quickSearchResults[0]
                && this.communityDirectoryResults.quickSearchResults[0].filters
                    ? this.communityDirectoryResults.quickSearchResults[0].filters
                    : [];
            },
            displayRolodex() {
                return this.communityDirectoryResults && this.communityDirectoryResults.searchResults
                    && (this.communityDirectorySelectedLetterFilter || this.communityDirectoryResults.searchResults.length >
                        communityDirectoryPageConstant.constant.minimumCountForRolodex);
            },
            showSortByDropDown() {
                return this.communityDirectoryResults && this.communityDirectoryResults.searchResults &&
                    (this.communityDirectoryResults.searchResults.length > 0 || this.communityDirectorySelectedLetterFilter);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_responsive.scss';

    .community-directory{

        &__ribbon {
            padding-left: 20px;
            border-bottom: 1px solid $ypo-medium-gray;
        }
        &__component {
            background-color: $ypo-extra-light-gray;
            border-bottom: 1px solid $ypo-light-gray-background;
            border-right: 1px solid $ypo-light-gray-background;
            border-left: 1px solid $ypo-light-gray-background;
            border-bottom-left-radius: 8px;
            border-bottom-right-radius: 8px;
        }
    }

    .filter-ribbon {
        padding-bottom: 10px;

        &__title {
            font-weight: 600;
            font-size: 16px !important;
            color: $black;
            font-family: 'Gentona', sans-serif;
            letter-spacing: 0.29px;
            line-height: 24px;
            padding: 5px 15px;
        }

        &__button {
            color: $ypo-cta;
            font-size: 16px;
            line-height: 37px;
            letter-spacing: 0.39px;
        }

    }

    .list-frame {
        background-color: $ypo-extra-light-gray;
        padding: 0 20px 30px 10px;
        border: 1px solid $ypo-light-gray;
        margin-top: -2px;
        border-bottom-left-radius: 8px !important;
        border-bottom-right-radius: 8px !important;

        &__title {
            color: $ypo-blue;
            font-family: "Noto Sans", sans-serif;
            font-size: 14px;
            font-weight: bold;
            letter-spacing: 0.23px;
            line-height: 24px;
        }

        &__button {
            &-label {
                margin-right: 3px;
            }
        }

        &__actions {
            position: absolute;
            right: 15px;
            top: 5px;

        }
    }

    .bar-border {
        border-bottom: 1px solid $ypo-tile-border !important;
    }

    .bold-ribbon {
        color: $ypo-blue;
        font-weight: 600;
    }

    .rolodex-wrapper {
        padding-left: 5px;
        padding-top: 5px;
        border-bottom: 1px solid $ypo-light-medium-gray;

        @include breakpoint(xs) {
            padding-left: 10px !important;
        }

        &__sort-by {
            flex: 0 1 auto;
        }

        &__rolodex {
            margin-top: -8px;
        }
    }
</style>

<style lang="scss">
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_commonClasses.scss';

    .community-directory {
        @extend %ypo_checkbox;

        .disabled-tab {
            .v-tabs__item {
                pointer-events: none;
                color: $ypo-medium-gray !important;
            }
        }

        &__list {
            .v-tabs {
                &__item {
                    text-transform: none;
                    color: $ypo-cta;
                    font-size: 14px;
                    line-height: normal;
                    opacity: 1 !important;
                    z-index: 2;
                    padding: 10px 15px 0;

                    &--active {
                        background-color: $ypo-extra-light-gray;
                        border-top: 1px solid $ypo-light-gray;
                        border-right: 1px solid $ypo-light-gray;
                        border-left: 1px solid $ypo-light-gray;
                        border-top-left-radius: 8px;
                        border-top-right-radius: 8px;
                    }
                }
            }
        }
    }
</style>

